import { render } from "./comments.vue?vue&type=template&id=70364e95&ts=true"
import script from "./comments.vue?vue&type=script&lang=ts"
export * from "./comments.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__